/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Track pair setting update request
 */
export interface TrackPairSettingUpdateRequest {
  id: number;
  /**
   * NULL is unlimited
   */
  hour?: number;
  disabled: boolean;
}
